import { render, staticRenderFns } from "./NoDataSelectItem.vue?vue&type=template&id=7195bdcc"
var script = {}
import style0 from "./NoDataSelectItem.scss?vue&type=style&index=0&prod&lang=scss&module=true&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports